import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { fmtQ } from "@/merenda/common";

export const StockAlerts = ({ scopeParams, reloadKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/merenda/alerts", { params: scopeParams }).then((r) => setData(r.data)).catch(() => setData(null)); }, [scopeParams, reloadKey]);
  if (!data || !data.alerts.length) return null;
  return (
    <Card className="mb-5 border-red-200 bg-red-50/60 p-4" data-testid="stock-alerts">
      <div className="mb-2 flex items-center gap-2 font-semibold text-red-700"><AlertTriangle className="h-4 w-4" /> {data.alerts.length} alimento(s) com estoque para menos de {fmtQ(data.limit_days)} dia(s) de merenda</div>
      <div className="grid gap-1 sm:grid-cols-2 lg:grid-cols-3">
        {data.alerts.map((a) => (
          <div key={a.food_id} className="rounded-lg bg-white px-3 py-2 text-sm" data-testid={`stock-alert-${a.food_id}`}>
            <b>{a.name}</b>: {fmtQ(a.balance)} {a.unit} · ~{fmtQ(a.coverage_days)} dia(s)
            <div className="text-xs text-slate-500">consumo médio {fmtQ(a.daily)} {a.unit}/dia</div>
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs text-slate-500">Base: {data.source}.</p>
    </Card>
  );
};
